import { getRequestEvaluations } from 'lib/api/decisionEngine';
import AlertBanner from 'lib/designSystem/AlertBanner';
import React from 'react';
import { useDispatch } from 'react-redux';

type EvaluationStatus = 'Rechazado' | 'Aprobado' | 'Default';

const STATUS_CONFIG: Record<
  EvaluationStatus,
  {
    severity: 'error' | 'success' | 'info';
    title: string;
    message: string;
  }
> = {
  Rechazado: {
    severity: 'error',
    title: 'Garantía Rechazada',
    message: 'La ultima evaluación de riesgo de la garantía ha sido rechazada.',
  },
  Aprobado: {
    severity: 'success',
    title: 'Garantía Aprobada',
    message: 'La ultima evaluación de riesgo de la garantía ha sido aprobada.',
  },
  Default: {
    severity: 'info',
    title: 'Garantía en Comite',
    message: 'La garantía se encuentra en el comite de riesgo.',
  },
};

const getStatusConfig = (status?: string) =>
  STATUS_CONFIG[(status as EvaluationStatus) ?? 'Default'];

const EvaluationWarning: React.FC<{ id: number }> = ({ id }) => {
  const dispatch = useDispatch();
  const { data, isPending } = getRequestEvaluations(dispatch, {
    requestId: id,
    requestType: 'sgr-warranty-request',
  });

  const finalEvaluation = data?.default?.sort(
    (a, b) => b.createdAt - a.createdAt,
  )[0];
  const finalStatus = finalEvaluation?.statusNode.name;
  const { severity, title, message } = getStatusConfig(finalStatus);

  if (!finalEvaluation || isPending) return null;

  return <AlertBanner severity={severity} title={title} message={message} />;
};

export default EvaluationWarning;
